import { create } from "zustand"
import type { PageCommand } from "~/components/sidebar/search/types"

export interface SearchCommandsRegistration {
  commands: readonly PageCommand[]
  /** Registered behind an open FullPageDialog, so hidden until it closes */
  covered: boolean
}

type SearchCommandsStore = {
  /** Keyed by the registering component's `useId`, in mount order */
  registrations: Record<string, SearchCommandsRegistration>
  register: (key: string, registration: SearchCommandsRegistration) => void
  unregister: (key: string) => void
  /** Set by a page hotkey to open the command menu inside a command's sub-list */
  openRequest: { path: readonly string[] } | null
  requestOpen: (path: readonly string[]) => void
  clearOpenRequest: () => void
}

export const useSearchCommandsStore = create<SearchCommandsStore>((set) => ({
  registrations: {},
  register: (key, registration) =>
    set((state) => ({ registrations: { ...state.registrations, [key]: registration } })),
  unregister: (key) =>
    set((state) => {
      if (!(key in state.registrations)) return state
      const { [key]: _, ...registrations } = state.registrations
      return { registrations }
    }),
  openRequest: null,
  requestOpen: (path) => set({ openRequest: { path } }),
  clearOpenRequest: () => set({ openRequest: null }),
}))
